//import FBInstantGameImage from './FBInstantGameImage.js'

export default class FBInstantGame {
    constructor() {
        this.isOnFacebook = !(typeof (FBInstant) === "undefined");
        this.isNotOnFacebook = (typeof (FBInstant) === "undefined");
        //this.base64Image = FBInstantGameImage.getImage();
        this.onLoaded = function () { };
        this.onInvite = function () { };
        this.isInitialized = false;
    }

    async initialize() {
        if (!this.isOnFacebook) {
            console.log("FBInstant is not loaded : initialize()");
            return;
        }
        if (this.isInitialized) {
            console.log("FBInstant is already Initialized : initialize()");
            return;
        }

        FBInstant.setLoadingProgress(70);
        await FBInstant.initializeAsync();

        //skipping game loading and pushing forward with loading done  

        FBInstant.setLoadingProgress(100);
        await FBInstant.startGameAsync()


        this.isInitialized = true;
    }

    subscribeBot() {
        FBInstant.player.canSubscribeBotAsync().then(
            function (can_subscribe) {
                if (can_subscribe) {
                    FBInstant.player.subscribeBotAsync().then(
                        // Player is subscribed to the bot
                    ).catch(function (e) {
                        // Handle subscription failure
                    });
                }
            }
        );
    }
    async getProfile() {
        if (!this.isOnFacebook) {
            console.log("FBInstant is SDK not loaded : loadProfileData()");
            return;
        }
        if (!this.isInitialized) {
            console.log("FBInstant is not Initialized : loadProfileData()");
            return;
        }

        console.log("FBInstant.loadProfileData()");
        // Retrieving context and player information can only be done once startGameAsync() resolves
        var contextId = FBInstant.context.getID();
        var contextType = FBInstant.context.getType();

        var playerName = FBInstant.player.getName();
        var playerPic = FBInstant.player.getPhoto();
        if (playerPic && playerPic.length > 1000) playerPic = null; //check for bad pic data.  It can come in as a string of 1,000+ characters

        var playerId = FBInstant.player.getID();
        var locale = FBInstant.getLocale();
        console.log("FBInstant.startGameAsync() - Done");


        let profileData = {
            name: playerName,
            pic: playerPic,
            id: playerId,
            locale: locale
        };

        return profileData;
    }
    async getInvite() {
        if (!this.isOnFacebook) {
            console.log("FBInstant is SDK not loaded : loadEntryPoint()");
            return;
        }
        if (!this.isInitialized) {
            console.log("FBInstant is not Initialized : loadEntryPoint()");
            return;
        }

        console.log("FBInstant.loadEntryPoint()");


        let entryPointData = FBInstant.getEntryPointData();
        console.log("FBInstant.getEntryPointData()", entryPointData);

        let inviteData = null;
        //check for invite
        if (entryPointData && entryPointData.room) {
            inviteData = {
                room: entryPointData.room,
                message: entryPointData.message,
                server: entryPointData.server || ''
            }

        }
        return inviteData;
    }
    async loadData() {
        if (!this.isOnFacebook) {
            console.log("FBInstant is SDK not loaded : loadData()");
            return;
        }
        if (!this.isInitialized) {
            // Retrieving context and player information can only be done once startGameAsync() resolves
            console.log("FBInstant is not Initialized : loadData()");
            return;
        }

        console.log("FBInstant.loadData()");

        let userData = null;
        try {
            let data = await FBInstant.player.getDataAsync(["userdata"]);
            userData = data?.["userdata"] ?? null;
            if (typeof userData !== 'object') userData = null;
        } catch (err) {
            console.log('FBInstant.getDataAsync() - caught exception', err);
        }
        return userData;
    }
    async saveData(userdata, forceSave) {
        if (typeof (FBInstant) === "undefined") return Promise.resolve();
        if (!userdata) return Promise.resolve();
        if (!userdata.facebookId && !forceSave) return Promise.resolve();

        return FBInstant.player
            .setDataAsync({
                userdata: userdata
            })
            .then(function () {
                console.log('FBInstant data saved');
            })
            .then(function () {
                if (forceSave) {
                    console.log('FBInstant flushDataAsync');
                    return FBInstant.player.flushDataAsync();
                }
            }).catch(function (ex) {
                console.log("FBInstant.player.setDataAsync() - catch - " + ex);
                console.log(ex);
            });
    }

    loadProfileDataTest() {
        var playerName = "Jimmy";
        var playerPic = "https://scontent-sjc3-1.xx.fbcdn.net/v/t1.0-1/11139003_10152870794711964_3739797864585429440_n.jpg?_nc_cat=0&oh=2fff2747f02b3c56054c5e192199bff6&oe=5B6FEEF1";
        var playerId = "1472723356169778";
        playerPic = encodeURIComponent(playerPic);
        var data = {
            playerName: playerName,
            playerPic: playerPic,
            playerId: playerId,
            entryPointData: null
        };
        return data;
    };
    invitePlayer(playerId, roomName) {
        //needs to be a string
        playerId = playerId + "";

        if (typeof (FBInstant) === "undefined") {
            console.log("FBInstant is not loaded");
            return;
        }
        if (!roomName) roomName = Math.floor(Math.random() * Math.floor(1000000000));
        var message = 'You have been challenged to a game!'
        var contextId = FBInstant.context.getID();

        //ask to share
        FBInstant.context.createAsync(playerId)
            .then(function () {
                console.log("FBInstant.context.choose() " + FBInstant.context.getID());
                // 1234567890
                //roomName = FBInstant.context.getID();
                this.updateAsyncRoom(message, roomName);
            }.bind(this)).catch(function (ex) {
                if (ex.code == "SAME_CONTEXT") {
                    //roomName = FBInstant.context.getID();
                    this.updateAsyncRoom(message, roomName);
                    //window.location.href = "#/Game/Online/" + roomName;
                }

                console.log("FBInstant.context.choose() " + JSON.stringify(ex));
                // 1234567890
            }.bind(this));

        return true;
    };
    inviteSend(userdata, roomName) {
        if (typeof (FBInstant) === "undefined") {
            console.log("FBInstant is not loaded");
            return;
        }
        var message = 'You have been challenged to a game!'
        var contextId = FBInstant.context.getID();
        if (userdata && userdata.name) message = userdata.name + ' has challenged you to a game!';
        if (!roomName && userdata && userdata.facebookId) roomName = userdata.facebookId;
        if (!roomName && contextId) roomName = contextId;
        if (!roomName) roomName = Math.floor(Math.random() * Math.floor(1000000000));

        //ask to share
        FBInstant.context.chooseAsync({ maxSize: 2 })
            .then(function () {
                console.log("FBInstant.context.choose() " + FBInstant.context.getID());
                // 1234567890
                //roomName = FBInstant.context.getID();
                this.updateAsyncRoom(message, roomName);
            }.bind(this))
            .catch(function (ex) {
                if (ex.code == "SAME_CONTEXT") {
                    console.log("FBInstant.context.choose() " + FBInstant.context.getID());
                    //roomName = FBInstant.context.getID();
                    this.updateAsyncRoom(message, roomName);
                    //window.location.href = "#/Game/Online/" + roomName;
                }

                console.log("FBInstant.context.choose() " + JSON.stringify(ex));
                // 1234567890
            }.bind(this));
    };
    updateAsyncRoom(message, roomName) {
        if (typeof (FBInstant) === "undefined") {
            console.log("FBInstant is not loaded");
            return;
        }

        FBInstant.updateAsync({
            action: 'CUSTOM',
            cta: 'Play',
            //image: this.base64Image,
            text: {
                default: message,
                localizations: {
                    en_US: message,
                    pt_BR: message,
                }
            },
            template: 'room_created',
            data: {
                message: message,
                room: roomName
            },
            strategy: 'IMMEDIATE',
            notification: 'PUSH',
        }).then(function () {
            console.log('Message was sent successfully');
            console.log('room created and entered: ' + roomName);
            var data = {
                message: message,
                room: roomName
            };
            //get new game room
            if (this.onInvite) {
                this.onInvite(data);
            }
        }.bind(this)).catch(function (ex) {
            console.log('Facebook.challenge Error: ' + ex);
            console.log(ex);
            console.log(JSON.stringify(ex));

        }.bind(this));
    }
    getConnectedPlayersAsync() {
        if (typeof FBInstant == "undefined") {
            return new Promise((resolve, reject) => reject('FBInstant is not loaded'));
        }
        try {
            return FBInstant.player.getConnectedPlayersAsync();
        } catch (ex) { //bug in IE11 with facebook script crashing before promise is created
            console.log("FBInstant.getConnectedPlayersAsync() - catch - " + ex);
            return;
        }
    }
    shareAsync(base64Data, text) {
        if (typeof FBInstant == "undefined") return Promise.resolve(false);
        FBInstant.shareAsync({
            image: base64Data,
            text: text,
            data: {},
        }).then(function () {
            // continue with the game.
        });
    };
    canCreateShortcut() {
        if (typeof FBInstant == "undefined") return Promise.resolve(false);
        return FBInstant.canCreateShortcutAsync();
    }
    createShortcut() {
        if (typeof FBInstant != "undefined") {
            console.log("canCreateShortcutAsync");
            FBInstant.canCreateShortcutAsync()
                .then(function (canCreateShortcut) {
                    if (canCreateShortcut) {
                        console.log("canCreateShortcut = " + canCreateShortcut);

                        FBInstant.createShortcutAsync()
                            .then(function () {
                                // Shortcut created
                                console.log("canCreateShortcutAsync - Shortcut created");
                            })
                            .catch(function () {
                                // Shortcut not created
                                console.log("canCreateShortcutAsync - Shortcut not created");
                            });
                    }
                });
        }
    }
    switchGameAsync(id) {
        if (typeof FBInstant == "undefined") return Promise.resolve(false);
        return FBInstant.switchGameAsync(id);
    }
}